<div class="color-picker-toolbar">
  <!-- Hex Input -->
  <mode-hex-input
    class="toolbar-text-input"
    [currentColor]="currentColor"
    (hexUpdated)="onColorSelected($event)"
  ></mode-hex-input>

  <!-- Reset CTA -->
  <capra-icon-button
    class="icon-toolbar-cta"
    icon="icon-reset"
    data-test="reset-hex-cta"
    capraTooltip
    tooltipPlacement="bottom"
    tooltipContent="Reset"
    (clicked)="onResetClick()"
  ></capra-icon-button>

  <!-- Copy CTA -->
  <capra-icon-button
    class="icon-toolbar-cta"
    icon="icon-copy-chart"
    data-test="copy-hex-cta"
    capraTooltip
    tooltipPlacement="bottom"
    tooltipContent="Copy"
    modeClipboard
    [clipboardText]="currentColor"
  ></capra-icon-button>

  <!-- Color Dropper -->
  <mode-color-dropper (colorSelected)="onColorSelected($event)"></mode-color-dropper>
</div>
